var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUnion = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17.999,
  height: 17.999,
  viewBox: "0 0 17.999 17.999"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Union_4",
  "data-name": "Union 4",
  d: "M5.5,17.292A9.03,9.03,0,1,1,9,18,8.98,8.98,0,0,1,5.5,17.292ZM1.636,9A7.364,7.364,0,1,0,9,1.636,7.372,7.372,0,0,0,1.636,9Zm6.545,3.273V9A.818.818,0,1,1,9.818,9v3.273a.818.818,0,0,1-1.637,0ZM8.045,6.136A.955.955,0,1,1,9,7.091.954.954,0,0,1,8.045,6.136Z",
  fill: "#7b7b7b"
})));
export { SvgUnion as ReactComponent };
export default __webpack_public_path__ + "static/media/Union.115d2dd7e69fdc7f52a3d5ecf323807e.svg";